import React, { Fragment } from 'react';

import { connect } from 'react-redux';

import { AppState, Actions, store, IPageState } from './../../appredux';

import { SerwisService, VatTableRowFromTo } from './../../api';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import theme from './../../themes';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';

import ReactDataGrid from '@inovua/reactdatagrid-community';
import '@inovua/reactdatagrid-community/index.css';

import SearchIcon from '@material-ui/icons/Search';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
// import HistorySharpIcon from '@material-ui/icons/HistorySharp';
// import EditIcon from '@material-ui/icons/Edit';

import './DataGrid.css';
import { CellProps } from '@inovua/reactdatagrid-community/Layout/ColumnLayout/Cell/CellProps';
import { Tooltip, Icon, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';
import { datediff, weekDay } from './../common/helpers';

//PM 2021-10-21
//wstrzykniecie tylko uzywanych pol z magazynu danych
//wyrzucenie ladowanie
interface TabelaHotelProps extends WithStyles<typeof styles> {
    page: IPageState,
    tableBody: VatTableRowFromTo[],
    selectStatus: (Status: VatTableRowFromTo) => void
    addToCart: (aDokNr: string) => void
    //historiaMenu: SerwisMenu[],
    //serwisMenuItem: number,
    //hotelId: string,
    //zakladkaHotel: string,

    //ukryjHotel: (hotel: SerwisHotel) => Promise<void>,
}

//PM 2021-10-21
//wyrzucenie ladowanie
interface TabelaHotelState {
    ukryteKolumny: string[],
    //openConfirm: boolean,
    //hotel: SerwisHotel
}

class TabelaHotel extends React.Component<TabelaHotelProps, TabelaHotelState>  {

    //PM 2021-09-17
    constructor(props: TabelaHotelProps) {
        super(props, {});
        this.state = {
            ukryteKolumny: [],
            //openConfirm: false,
            //hotel: new SerwisHotel
        }
    }

    // openConfirm = (data: SerwisHotel) => {
    //     this.setState({ openConfirm: true, hotel: data });
    // };

    // closeConfirm = () => {
    //     this.setState({ openConfirm: false });
    // };

    // ukryjHotel = async () => {
    //     this.props.ukryjHotel(this.state.hotel)
    // };

    //PM 2021-10-25
    //podlaczenie do API
    selectStatus = async (aSerwisHotel: any) => {
        //let historiaMenu = this.props.historiaMenu

        //historiaMenu.push(this.props.serwisMenuItem)
        //await this.setLadowanie()
        //await store.dispatch(Actions.pageState.selectStatus(aSerwisHotel.hotelId, historiaMenu, SerwisMenu.status));
        this.props.selectStatus(aSerwisHotel);
        //await this.resetLadowanie()
    };

    addToCart = async (aDokNr: string) => {
        this.props.addToCart(aDokNr);
    };

    //PM 2021-10-25
    //podlaczenie do API
    // selectHotelHistoria = async (aSerwisHotel: SerwisHotel) => {
    //     //let historiaMenu = this.props.historiaMenu

    //     //historiaMenu.push(this.props.serwisMenuItem)

    //     await store.dispatch(Actions.pageState.selectHotelHistoria(aSerwisHotel.hotelId, historiaMenu, SerwisMenu.hotelHistoria, aSerwisHotel.data.split(' ')[0]));
    //     //await this.setLadowanie()
    //     //await store.dispatch(Actions.pageState.setSerwisHotelHistoriaTablica(serwisHotelHistoria));
    //     //await this.resetLadowanie()   
    // };


    //PM 2021-10-25
    //podlaczenie do API
    cellRender = ({ value, data, cellProps }: any) => {
        const { classes } = this.props;
        let date = new Date(data.data)
        date.setHours(2)
        let dateNow = new Date()
        dateNow.setHours(5)

        let color = theme.palette.primary.main
        let daysDifference = datediff(date, dateNow ) 

        if(daysDifference > 2){ //rekordy starsze niż 3 dni na szaro
            color = "rgba(0, 0, 0, 0.36)"
        }else if (cellProps.name.includes('iloscPorazka') && Number(value) > 0) {
            color = theme.palette.error.main
        }

        const fontWeight = cellProps.name === "brutto" ? 'bold' : 'normal';
        //const lastPage = this.props.hotelId.length && this.props.hotelId === data.hotelId;
        const lastPage = false;

        if (cellProps.columnIndex === 0) {
            return (
                <div onClick={async () => await this.selectStatus(data)} className={classes.cursorPointer} style={lastPage ? { background: '#e65100', height: '48px' } : {}}>
                    {' '}
                </div>
            )
        } else if (cellProps.columnIndex === 4 - this.state.ukryteKolumny.length) {
            return (
                <div>

                    <Fragment>
                        <Tooltip title="szczegóły" classes={{tooltip: classes.tooltip}}>
                            <IconButton onClick={async () => await this.selectStatus(data)} style={{ padding: '0px 0px 0px 4px' }}>
                                <SearchIcon style={{ color: color, width: "20px", height: "20px" }} fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="do koszyka" classes={{tooltip: classes.tooltip}}>
                            <IconButton onClick={async () => await this.addToCart(data.dokNr)} style={{ padding: '0px 0px 0px 4px' }}>
                                <ShoppingCartIcon style={{ color: color, width: "20px", height: "20px" }} fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        {/* <Tooltip title="obiekt historia">
                                    <IconButton onClick={async () => await this.selectHotelHistoria(data)} style={{ padding: '0px 4px 0px 0px' }}>
                                        <HistorySharpIcon style={{ color: color }} fontSize="small" />
                                    </IconButton>
                                </Tooltip> */}
                        {/* <Tooltip title={this.props.zakladkaHotel === "4" ? "przywróć" : "ukryj"}>
                                    <IconButton onClick={() => this.openConfirm(data)} style={{ padding: '0px 4px 0px 0px' }}>
                                        <EditIcon style={{ color: color }} fontSize="small" />
                                    </IconButton>
                                </Tooltip> */}
                    </Fragment>
                        
                </div>
            )
        } else if (cellProps.columnIndex > 0 && cellProps.columnIndex < 23) {
            return (
                <div onClick={async () => await this.selectStatus(data)} className={classes.cursorPointer}>
                    <Typography
                        variant='body2'
                        style={{ color: color, fontWeight: fontWeight }}
                        className={`${classes.cell} ${classes.preLine}`}
                    >
                        {cellProps.name === "dataWyst" ? value + " " + weekDay(value) : value}
                    </Typography>
                </div>
            )
        }
    };

    headerRender = (value: string,) => {
        return (cellProps: CellProps) => {
            const { classes } = this.props;
            let hide = true

            if (cellProps.computedAbsoluteIndex == 0 || cellProps.name == "custom") {
                hide = false;
            }

            return (
                <div className={`${classes.tableHeadline}`} style={value == "" ? { height: "50px", marginLeft: "-4px", display: "flex" } : {}} onClick={() => { hide ? this.hideColumn((cellProps.name || "")) : this.showColumns() }}>
                    <p>{value}</p>
                </div>
            )
        }
    };


    // rowStyle = ({ data }: any) => {
    //     return {
    //         contain: "strict",
    //         color: "blue",
    //     }
    // }
      

    //PM 2021-10-25
    //podlaczenie do API
    customCellStyle = (cellProps: CellProps) => {
        let style: React.CSSProperties = {}
        const borderlessColumns = ['iloscSukces', 'iloscPorazka', 'iloscSukces1', 'iloscPorazka1', 'iloscSukces2', 'iloscPorazka2', 'iloscSukces3', 'iloscPorazka3', 'iloscSukces4', 'iloscPorazka4', 'iloscSukces5', 'iloscPorazka5', 'iloscSukces6', 'iloscPorazka6',]
        const greenBackground = ['brutto']
        const whiteBackground = ['asortymenty']

        if (cellProps.rowIndex === this.props.tableBody.length - 1)
            style = { ...style, borderBottom: 0 }
        //if (borderlessColumns.includes(cellProps.name || ""))
        //    style = { ...style, borderLeft: 'none' }
        if (greenBackground.includes(cellProps.name || ""))
            style = { ...style, background: 'rgb(245, 255, 245)' }
        if (whiteBackground.includes(cellProps.name || ""))
            style = { ...style, background: 'rgb(255, 255, 255)' }

            //style = { ...style, height: "50px" }

        return style
    };

    hideColumn = (n: string) => {
        let kolumny = this.state.ukryteKolumny
        kolumny.push(n)
        this.setState({ ukryteKolumny: kolumny })
    }

    showColumns = () => {
        this.setState({ ukryteKolumny: [] })
    }

    //PM 2021-10-25
    //podlaczenie do API
    render() {
        const classes = this.props.classes;
        //console.log(this.props.tableBody)

        let columns = [
            {
                name: 'OSTATNIA_STRONA', header: this.headerRender(''), maxWidth: 7.5, textAlign: 'center' as 'center', render: this.cellRender, draggable: false,
                headerProps: { style: { borderLeft: "0", height: '50px' }, className: `${classes.tableHeadline}` },
                style: this.customCellStyle,
                cellProps: { style: { padding: "0", } },

            },
            // {
            //     name: 'dokNr', header: this.headerRender('dokNr'), defaultFlex: 1, minWidth: 75, maxWidth: 100, textAlign: 'center' as 'center', render: this.cellRender, draggable: false,
            //     headerProps: { style: { height: '50px' }, className: `${classes.tableHeadline}` },
            //     style: this.customCellStyle,
            // },
            {
                name: 'dataWyst', header: this.headerRender('data'), defaultFlex: 1, minWidth: 150, maxWidth: 200, render: this.cellRender, draggable: false,
                headerProps: { style: { height: '50px' }, className: `${classes.tableHeadline}` },
                style: this.customCellStyle,
            },
            {
                name: 'brutto', header: this.headerRender('brutto'),  defaultFlex: 1, minWidth: 75, maxWidth: 100, textAlign: 'center' as 'center', render: this.cellRender, draggable: false,
                headerProps: { style: { height: '50px' }, className: `${classes.tableHeadline}` },
                style: this.customCellStyle,
            },
            {
                name: 'asortymenty', header: this.headerRender('asortymenty'), defaultFlex: 2, minWidth: 300, render: this.cellRender, draggable: false,
                headerProps: { style: { height: '50px' }, className: `${classes.tableHeadline}` },
                style: this.customCellStyle,
            },
            {
                name: 'custom', header: this.headerRender('akcje'), minWidth: 80, maxWidth: 80, textAlign: 'center' as 'center', render: this.cellRender, draggable: false,
                headerProps: { style: { height: '50px' }, className: `${classes.tableHeadline}` }, onclick: this.showColumns,
                style: this.customCellStyle,
                cellProps: { style: { padding: 0 } },
            },
        ];

        //ukrycie klikniętych kolumn
        this.state.ukryteKolumny.forEach((nazwaKolumny: string) => {
            columns = columns.filter(col => col.name !== nazwaKolumny)
        })

        const gridStyle = {
            minHeight: this.props.tableBody.length * 52+ 60 + 1, border: "0", fontSize: "12px"
        };

        return (
            <>
            <ReactDataGrid
                columns={columns}
                dataSource={this.props.tableBody}

                //onRowClick={this.selectRow}
                activeIndex={-1}

                showZebraRows//={false}
                showColumnMenuTool={false}
                sortable={false}
                resizable={false}
                showHoverRows={false}
                //showCellBorders={"horizontal"}

                style={gridStyle}
                //rowStyle={this.rowStyle}
                
                rowHeight={52}
                //minRowHeight={51}
                //maxRowHeight={51}
            />
                {/* <Dialog
                    disableEscapeKeyDown
                    maxWidth="xs"
                    open={this.state.openConfirm}
                    onClose={this.closeConfirm}
                    fullWidth
                >
                    <DialogTitle disableTypography style={{ minWidth: "280px" }}>
                        <Typography variant="h6" component="h2" color="primary">
                            <b>{"wybierz"}</b>
                        </Typography>
                        <hr />
                    </DialogTitle>
                    <DialogContent>
                       
                            <DialogContentText style={{ fontSize: "1rem", whiteSpace: "pre" }}>
                                {`Czy na pewno chcesz ${this.props.zakladkaHotel !== "4" ? "ukryć" : "przywrócić"} firmę?`}
                            </DialogContentText>
                        
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" color="primary" size="small" className={classes.button}
                            onClick={this.closeConfirm}>
                            <b>anuluj</b>
                        </Button>
                        <Button variant="contained" color="primary" size="small" className={classes.button}
                            onClick={this.ukryjHotel}>
                            <b>OK</b>
                        </Button>
                    </DialogActions>
                </Dialog> */}
            </>

        );
    }
}

const styles = (theme: Theme) => ({
    cell: {
        fontSize: "12px"
    },
    tableHeadline: {
        color: "seagreen",
        fontWeight: 'bold' as 'bold',
        backgroundColor: "rgb(247, 247, 247)",
        fontFamily: "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif",
        fontSize: "0.875rem",
        minWidth: "7.5px",
        margin: "auto",
        width: "-webkit-fill-available",
        cursor: "pointer"
    },
    margin: {
        //margin: theme.spacing(2) 
        margin: "auto"
    },
    preLine: {
        whiteSpace: 'pre-line' as 'pre-line'
    },
    seagreen: {
        color: 'seagreen',
        backgroundColor: "white",
    },
    cursorPointer: {
        cursor: 'pointer'
    },
    button: {
        textTransform: "none" as "none"
    },
    tooltip: {
        fontSize: "10px"
    }
});

const mapStateToProps = (state: AppState) => ({
    page: state.pageState,
});

export default connect(mapStateToProps)(withStyles(styles)(TabelaHotel));

